// extracted by mini-css-extract-plugin
export default {"root":"PathInput_root__IK0Ry","locale":"PathInput_locale__bwNuk","small":"PathInput_small__bvw9e","input":"PathInput_input__clKOc"};